import React from 'react';
import { useHistory } from 'react-router-dom';
import './index.less';
import PageLayout from '../../Components/pageLayout';
import data43 from '../../data/data43.json';
import ArticleList from '../../Components/ArticleList';

const CleanPeopleHeart: React.FC = () => {
    const history = useHistory();

    return (
        <PageLayout
            history={history}
            children={[]}
            Content={
                <div className='page-container'>
                    <h1 className='page-title'>清廉民心</h1>
                    <ArticleList dataId="43" data={data43 as any} />
                </div>
            }
        />
    );
};

export default CleanPeopleHeart;
